import { Injectable } from '@angular/core';
import { RoleRepositoryService } from 'src/app/core/repositories/admin/roles/role-repository.service';
import { IUserRoles } from './user-roles.models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserRolesStoreService {
  constructor(private repo: RoleRepositoryService) {}

  getUserRoles(): Observable<IUserRoles[]> {
    return this.repo.getUserRolesAuth();
  }
}
